/** GxToast: `useToast()(message)` shows a line for a few seconds (e.g. "FY2027 results are in"). */
import { createContext, useCallback, useContext, useState, type ReactNode } from "react";

const TOAST_MS = 6_000;
type Push = (message: string) => void;
const ToastContext = createContext<Push>(() => undefined);

export const useToast = (): Push => useContext(ToastContext);

export function ToastProvider({ children }: { readonly children: ReactNode }) {
  const [toasts, setToasts] = useState<readonly { readonly id: number; readonly message: string }[]>([]);
  const push = useCallback<Push>((message) => {
    const id = Date.now() + Math.random();
    setToasts((all) => [...all, { id, message }]);
    setTimeout(() => setToasts((all) => all.filter((t) => t.id !== id)), TOAST_MS);
  }, []);
  return (
    <ToastContext value={push}>
      {children}
      <div className="gx-toasts" role="status" aria-live="polite">{toasts.map((t) => <div key={t.id} className="gx-toast">{t.message}</div>)}</div>
    </ToastContext>
  );
}
